module.exports = __webpack_public_path__ + "static/media/icon-tea-cup.9f2b49b4.svg";